/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Fabian Greimel",
  title: "Hey! I am Fabi!",
  subTitle: 
 //   "Ich bin Fabian Greimel und ich bin passionierter ITler & Developer 🚀 mit Erfahrung in der Entwicklung von  Web und Mobile applications with Java / Spring / Kotlin / JavaScript / Reactjs / Nodejs / und weiteren spannenden Bibliotheken und Frameworks."
//"My name is Fabian Greimel and my heart beats for IT. In addition to IT, I have a great interest in the health sector, which is why I am studying health informatics. In my spare time, I enjoy photography, designing and developing web/mobile applications. I mostly use Kotlin, Jetpack Compose, Spring, JavaScript, React, NodeJS or SwiftUI for this.." 

//"I am a politically interested young guy that values justice, freedom, equality, fairness, and solidarity. Through my work with the Austrian National Union of Students (ÖH & VSSTÖ), I gained interest and experience in that field. I also have 10 years of IT experience and can easily adapt to new fields. In my free time I enjoy creating designs with the Figma, Canva or the Adobe Creative Suite, for projects or events for e.g. Landjugend Lassing. During my studies, I developed different Apps and Designs like the “Bedtime Buddy” App to improve sleep quality and wrote my bachelor thesis on digitalizing oncology to enhance care with IT solutions."
"I’m passionate about  <b>politics, design, IT, and marketing.</b>\n" 
+
"Through my involvement in student representation at ÖH during my studies, my role as a local councilor in Styria, and an internship at the EU Parliament in Brussels, I’ve gained valuable experience in political work.\n"
+ 
"Over the years, I’ve supported various events with marketing expertise, including the anniversary ball of LJ Lassing in fall 2024 and the student event Glüh Health at FH Joanneum."
+
"I’ve designed local product packaging for farm sales, such as honey and yoghurt, and developed a smart mirror during my studies.\n"
+
"My creative work extends to photography on Instagram, app development and website creation."
+
"With 10 years of IT experience and expertise in design tools like Figma, Canva, and the Adobe Creative Suite, I bring ideas to life in the digital world!\n"
+
"Feel free to scroll down and check out my projects and information in detail!"
,
  resumeLink:
    "https://drive.google.com/file/d/1hjOeYgtLLZZ-SCWq5TcR7QID8BdQZQgS/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
    github: "https://github.com/greifadler",
    gmail: "fabiangreimel@gmail.com",
  instagram: "http://instagram.com/styrialabs",
  display: true
};

// Skills Section

const skillsSection = {
  title: "Technical Expertise",
  subTitle: "Besides my political interest I have a high technical expertise, which I built up in the past 10 years. I have a wide range of IT skills, I would say I have worked in all major fields and could easily familiarise myself with any new area.",
  categories: [
    {
      name: "Information Technology",
      skills: 
      [
        { 
          title: "Software Development: ",
          text: "Experienced in Java, PHP, JavaScript, and more, helping develop the Gymky App at Liebrecht & Haas, learned it 5 years in school and 3 years in my studies."
         }
        ,
        { 
          title: "Networking & Troubleshooting: ",
          text: "Solved problems such as recovering virus-infected computers and restoring data at Ennstal IT."
         }
        ,
        { 
          title: "Web Development: ",
          text: "Built websites like Unfold Potential featuring a complete booking portal for recurring patient appointments, and many more."
         }
      ],
      
    },
    {
      name: "Design & Creativity",
      skills: 
      [
        { 
          title: "Social Media: ",
          text: "Enhanced the öh joanneum Instagram by redesigning it for clarity and increasing engagement and likes in the first month."
         }
        ,
        { 
          title: "Campaigns & Events: ",
          text: "Created campaigns and marketing materials for events like 'Jubiläumsball' and 'Waldfest' for Landjugend Lassing, which were highly attended. "
         }
        ,
        { 
          title: "Logos: ",
          text: "Designed logos, posters, and promotional materials for various purposes."
         }
      ],
    },
    
    {
      name: "eHealth",
      skills: 
      [
        { 
          title: "Apps & Sensors: ",
          text: "Developed solutions like the Bedtime Buddy App to improve sleep quality."
         }
        ,
        { 
          title: "Bachelor thesis: ",
          text: "Digitalisation in Oncology - Analysis of international IT solutions for cancer therapy and guidelines for implementation in Austria. "
         }
        ,
        { 
          title: "Standards: ",
          text: "Deep understanding of standards such as ICD-10, LOINC, HL7, and FHIR."
         }
      ],
    },
    ],
    softwareSkills: [
      {
          skillName: "Kotlin & Compose",
          fontAwesomeClassname: "fab fa-android"
      },
      {
          skillName: "Swift",
          fontAwesomeClassname: "fab fa-swift"
      },
      {
          skillName: "Java",
          fontAwesomeClassname: "fab fa-java"
      },
      {
        skillName: "Figma",
        fontAwesomeClassname: "fab fa-figma"
    },
  {
    skillName: "HTML",
    fontAwesomeClassname: "fab fa-html5"
  },
  {
    skillName: "CSS",
    fontAwesomeClassname: "fab fa-css3-alt"
  },
  {
    skillName: "JavaScript",
    fontAwesomeClassname: "fab fa-js"
  },
  {
    skillName: "NodeJS",
    fontAwesomeClassname: "fab fa-node"
  },
  {
    skillName: "SQL",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "Windows",
    fontAwesomeClassname: "fab fa-windows"
  },
  {
    skillName: "Python",
    fontAwesomeClassname: "fab fa-python"
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "fab fa-docker"
  }
],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */


  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "HTBLA Kaindorf an der Sulm",
      logo: require("./assets/images/kaindorf-logo.png"),
      subHeader: "Computer Science & Economics",
      duration: "September 2014 - June 2019",
          desc: "At the technical college I learnt programming skills in Java, C, C#, HTML, CSS, JS and SQL. I also learnt how to use agile programming (Scrum) and how to carry out my own projects. Business administration and management and specialising in IT security were further focal points of my training.",
      descBullets: [
        "Java, C#, C, HTML, CSS, JS",
          "SQL, NoSQL, Oracle, Postgres, MySQL, Neo4J, Redis",
        "IT-Security"
      ]
    },
    {
      schoolName: "University of applied sciences Joanneum",
      logo: require("./assets/images/fhj-logo.png"),
        subHeader: "Bachelor's degree programme in medical informatics & eHealth",
      duration: "September 2021 - September 2024",
        descBullets: [
            "Understanding the Austrian & international healthcare systems",
            "How can the documentation effort in the medical field be simplified?",
            "How can digitalisation simplify and optimise life in the health and care sector?"
        ]
    },    
    {
      schoolName: "University of applied sciences Inholland Haarlem",
      logo: require("./assets/images/inholland-logo.png"),
        subHeader: "Semester abroad in the field of mobile development",
      duration: "September 2023 - January 2024",
        descBullets: [
            "Learn how to independently create a functional mobile application including a backend for a client in a team.",
            "Creating an application called Anno Amsterdam, which uses AR and maps to show the historical details of the buildings in Amsterdam in a simple and intuitive way.",
            "Learning UI and UX skills with prototypes on paper and in Figma.",
            "Native development of applications for Android and iOS with Jetpack Compose and SwiftUI"
        ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Coding", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Web Development",
      progressPercentage: "85%"
    },  
    {
      Stack: "Design",
      progressPercentage: "85%"
    },
    {
      Stack: "Photography",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Internship - Politics & Public relations",
      company: "European Parliament",
          companylogo: require("./assets/images/euparl.jpg"),
      date: "January 2025 - June 2025",
      desc: "Worked for MEP Elisabeth Grossmann in Brussels, improved EU knowledge, international experience and policy research.",
      descBullets: [
      "Social media, content creation, PR, Design",
      "AI, Internal Market and Consumer Protection",
      "Women’s Rights and Gender Equality"
      ]
    },
    {
      role: "Internship - Mobile Researcher",
      company: "Gymky",
          companylogo: require("./assets/images/gymky.webp"),
      date: "March 2024 - June 2024",
      desc: "Analysis of the user interface (UI), the user experience (UX) and the security of the app. Helping in the development of the app in Flutter.",
      descBullets: [
      "UI / UX Design for mobile apps",
      "Research Flutter & Smartwatches",
      "Apple Health / Google Health Connect"
      ]
    },
    {
      role: "Software Engineer - Mobile & Web",
      company: "Liebrecht & Haas GmbH",
          companylogo: require("./assets/images/liebrecht-haas-logo.png"),
      date: "January 2023 – August 2023",
      desc: "Development of web projects with PHP and Laravel.  Assistance in the development of mobile applications with Flutter.",
      descBullets: [
        "PHP, Laravell & Flutter",
          "JS, CSS & HTML"
      ]
    },
    {
      role: "Software Engineer - Full Stack",
      company: "Promed GmbH",
          companylogo: require("./assets/images/promed-logo.png"),
      date: "March 2021 – December 2022",
      desc: "Implementation of projects in Java and Kotlin. Focus on web applications, REST APIs and Android apps.",
      descBullets: [
        "Web development projects with Java and Spring",
          "Native Android apps with Kotlin and Jetpack Compose",
        "Wordpress projects"
      ]
    },
    {
      role: "IT technician",
      company: "Ennstal [IT]",
      companylogo: require("./assets/images/ennstal-it-logo.png"),
      date: "Fall 2019",
        desc: "Over a period of 2 months, I recorded, analysed and solved various problems for our customers. Examples of my work there include solving application errors, rectifying server failures, implementing server changes, setting up networks and rescuing data in the event of virus attacks."
    },
      {
          role: "Developer in NodeJS",
          company: "Pink Robin GmbH",
          companylogo: require("./assets/images/pink-robin-logo.png"),
          date: "Summer 2018",
          desc: "As a Node.js programmer, I developed an independent messaging service API as part of my diploma thesis. This sends Android & IOS push messages, emails and SMS."
      }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My projects",
  categories: [{
    title: "Event promotions",
    subtitle: "In this section of my projects you will find events for which I developed the designs and for which I was responsible for the advertising and planning. By clicking on the individual events you will get to a detail page, which shows more details about my work for these events.",
    projects: [
    {
      image: require("./assets/images/jubilaeumsball.png"),
      projectName: "Jubiläumsball",
      projectDesc: "For the 75th anniversary of Landjugend Lassing in 2024 we planned a grand celebration with an anniversary ball. I played a key role in the organization, overseeing design and marketing to ensure the event's success.",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2024/12/09/jubilaeumsball/"
        }
      ]
    },

    {
      image: require("./assets/images/theater2.png"),
      projectName: "Theatre",
      projectDesc: "I created posters and designed tickets for the 2024 and 2023 theatres of the Landjugend Lassing. Next to those I also created the social media posts for the theatre and planned and ran Social Media Ads. ",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2024/12/10/theater/"
        }
      ]
    },

    {
      image: require("./assets/images/waldfestq.png"),
      projectName: "Waldfest",
      projectDesc: "For the years 2024, 2023 and 2022 I created the poster designs for the 'Waldfest' of the Landjugend Lassing. I also made sure that posts were created for social media. In 2024 I took over the photography for the event. ",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2025/01/06/waldfest/"
        }
      ]
    },


    
    {
      image: require("./assets/images/gluehhealth.jpg"),
      projectName: "Glüh Health",
      projectDesc: "In my Job as class representative during my studies I took care of the planning, design and advertisement for the event, a mulled wine stand called 'Glüh Health', of our degree course at the FH Joanneum.",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2025/01/06/glueh-health/"
        }
      ]
    },


  ]},

  {
    title: "Concepts & Ideas",
    subtitle: "In this section, I present a selection of creative concepts and prototypes developed for my portfolio. Each project explores how design can translate emotions, environments, and everyday needs into engaging digital experiences.",
    projects: [


      {
        image: require("./assets/images/women.png"),
        projectName: "The Female Body and Mind:  A Visual Cycle",
        projectDesc: "An AI-generated art exhibition inspired by the emotional and physical realities of menstruation, pregnancy, and hormonal shifts—visualizing the unseen experiences of the female body and mind.",
        footerLink: [
          {
            name: "CONCEPT",
            url: "https://styrialabs.com/2025/04/20/the-female-body-and-mind-a-visual-cycle/"
          }
          //  you can add extra buttons here.
        ]
      },

      {
        image: require("./assets/images/exploregesaeuse.png"),
        projectName: "Explore Gesäuse AR",
        projectDesc: "Prototype of the 'Explore Gesäuse' app featuring AR, an interactive map, and info fields. It offers an immersive preview, allowing users to interact with peaks, huts, and plan trips easily.",
        footerLink: [
          {
            name: "BLOG & FIGMA",
            url: "https://styrialabs.com/2025/01/06/explore-gesaeuse/"
          }
          //  you can add extra buttons here.
        ]
      },

      {
        image: require("./assets/images/lassing_rural.png"),
        projectName: "Digital Futures in Rural Areas",
        projectDesc: "Two paths, one goal: This research concepts explores how digital policy and creative design can help reimagine rural futures in Lassing, Austria—combining tech solutions with emotional storytelling and local visions.",
        footerLink: [
          {
            name: "CONCEPT",
            url: "https://styrialabs.com/2025/04/16/digital-futures-in-rural-areas-two-research-pathways-for-revitalising-the-countryside/"
          }
          //  you can add extra buttons here.
        ]
      },

      {
        image: require("./assets/images/vinyl-app.png"),
        projectName: "Vinyl",
        projectDesc: "A mobile app design for a vinyl store to buy & sell records. Featuring 25 screens, it covers browsing, product details, and a seamless checkout process for an intuitive user experience.",
        footerLink: [
          {
            name: "FIGMA",
            url: "https://www.figma.com/design/jJKv46IHa8SoxdId0tX0MO/Vinyl-App"
          }
          //  you can add extra buttons here.
        ]
      },
    ]
  },

  {
    title: "Products",
    subtitle: "Here is an overview of products for which I have developed the design and thought about the concept behind them. My projects range from the conception and realisation of a smartmirror to sales products for local farmers.",
    projects: [

    {
      image: require("./assets/images/smartmirror.png"),
      projectName: "Smartmirror",
      projectDesc: "I built a Smartmirror using an old TV, Raspberry Pi, and custom React software. It displays time, news, weather, cleaning schedules, and Wi-Fi access via QR code—functional and cost-effective!",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2025/01/06/smart-mirror-out-of-the-box/"
        }
      ]
    },

    {
      image: require("./assets/images/honey.jpg"),
      projectName: "Honey design",
      projectDesc: "I was asked to create a design for beekeeper Hannes Lämmerer's home-made honey. When creating the design, it was important to fulfil all the requirements for a honey product in an appealing design.",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2024/12/10/honey/"
        }
      ]
    },

    {
      image: require("./assets/images/Jam-jar-mockup-10.png"),
      projectName: "Yoghurt design",
      projectDesc: "I designed a yoghurt label for the Mojer family from Lassing, who make homemade yoghurt. The design is visually appealing, aligns with the product’s name, and meets all yoghurt packaging requirements.",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/2024/12/10/yogurt-design/"
        }
      ]
    },

     {
      image: require("./assets/images/styrialabs2.jpg"),
      projectName: "Photography",
      projectDesc: "On this website, you'll find impressions of landscape, holiday, and animal photos, as well as portraits of me—capturing unique moments, memories, and emotions from different perspectives.",
      footerLink: [
        {
          name: "DETAILS",
          url: "https://styrialabs.com/photography/"
        }
      ]
    },
  
  ]},

    {
    title: "Apps",
    subtitle: "I designed and developed apps for various projects, putting a lot of love into them.",
    projects: [
    {
      image: require("./assets/images/anno-adam.png"),
      projectName: "Anno Amsterdam",
      projectDesc: "A mobile app for residents & tourists to explore Amsterdam's historic buildings using AR. Discover stories, visuals, and history in an interactive and engaging way through your device.",
      footerLink: [
        {
          name: "BLOG, FIGMA & GITHUB",
          url: "https://styrialabs.com/2025/04/15/anno-amsterdam-augmented-reality-meets-cultural-heritage/"
        },

      ]
    },
  



    
    {
      image: require("./assets/images/bedtime-buddy.jpg"),
      projectName: "Bedtime Buddy",
      projectDesc: "An Android app built with Java that uses the light sensor to wake you up and tracks your sleep using your phone's microphone, offering insights for better sleep quality and healthier routines.",
      footerLink: [
        {
          name: "GITHUB",
          url: "https://github.com/greifadler/bedtimebuddy"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/newsreader-compose.png"),
      projectName: "The Reader",
      projectDesc: "An Android app to read newspaper articles, built using Jetpack Compose and Kotlin, providing a modern, user-friendly interface for reading and navigating articles seamlessly.",
      footerLink: [
        {
          name: "GITHUB",
          url: "https://github.com/greifadler/newsreader"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/pokedex-ios.png"),
      projectName: "Pokedex",
      projectDesc: "An iOS app built with Swift & SwiftUI to save your favorite Pokémon and search for Pokémon, offering a user-friendly interface to manage and explore your Pokémon collection.",
      footerLink: [
        {
          name: "GITHUB",
          url: "https://github.com/greifadler/pokedex-ios"
        }
        //  you can add extra buttons here.
      ]
    }]},
    {
      title: "Websites",
      subtitle: "My websites, that I have enjoyed creating a lot",
      projects: [
    {
      image: require("./assets/images/osg-logo.png"),
      projectName: "Osteopathin Lassing",
      projectDesc: "A website showcasing the activities of osteopath Sonja Greimel, along with Google Business management for enhanced online visibility and client engagement.",
      footerLink: [
        {
          name: "To the website",
          url: "http://heilmasseurin-lassing.at/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/up-logo.png"),
      projectName: "Unfold Potential",
        projectDesc: "A website for clinical psychologist and cranio-sacral therapist Kathrin Großschedl, representing Unfold Potential, with features for booking and paying for appointments directly online.",
      footerLink: [
        {
          name: "To the website",
              url: "https://unfold-potential.co/"
        }
      ]
      },
      {
        image: require("./assets/images/frischeparadies-thomueller.png"),
        projectName: "Frischeparadies Thomüller",
          projectDesc: "A website for the Thomüller delicatessen in Graz, showcasing the business of the Thomüller brothers and offering a direct online contact option for customer inquiries and engagement.",
        footerLink: [
          {
            name: "To the website",
                url: "https://frischeparadies.at/"
          }
        ]
        },
        {
          image: require("./assets/images/gut-geordnet.png"),
          projectName: "Gut Geordnet",
            projectDesc: "A website for Manuela Gutschlhofer, representing her company focused on creating tidiness, offering services to help clients organize and declutter their spaces effectively.",
          footerLink: [
            {
              name: "To the website",
                  url: "https://www.gutgeordnet.at/"
            }
          ]
          }
        ]
      }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Some photos you have worked on

const photos = {
  title: "Meine bisherigen Fotos",
  subtitle: "Meine liebsten Fotos die ich mit meiner Kamera gemacht habe",
  pictures: [
    {
      image: require("./assets/images/osg-logo.png"),
      projectName: "Osteopathin Lassing",
      projectDesc: "Eine Website zur Präsentation der Tätigkeiten der Osteopathin Sonja Greimel.",
      footerLink: [
        {
          name: "Zur Website",
          url: "http://heilmasseurin-lassing.at/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/up-logo.png"),
      projectName: "Unfold Potential",
        projectDesc: "Eine Website für die klinische Psychologin und CranioSacral Therapeutin Kathrin Großschedl. Die Website repräsentiert die Arbeit von Unfold Potential und bietet die Funktion direkt online einen Termin zu buchen und zu verrechnen.",
      footerLink: [
        {
          name: "Zur Website",
              url: "https://unfold-potential.co/"
        }
      ]
      },
      {
        image: require("./assets/images/frischeparadies-thomueller.png"),
        projectName: "Frischeparadies Thomüller",
          projectDesc: "Eine Website für die Feinkosthändler Thomüller in Graz. Die Website repräsentiert den Betrieb der beiden Thomüller Brüder und bietet die Funktion direkt online in Kontakt mit dem Unternehmen zu treten.",
        footerLink: [
          {
            name: "Zur Website",
                url: "https://frischeparadies.at/"
          }
        ]
        },


  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Papers and certificates 🏆",
  subtitle:
    "Project work, certificates, awards and much more that I have done so far!",

  achievementsCards: [

    {
      title: "Analysis of international IT solutions for cancer therapy and guidelines for implementation in Austria",
      subtitle:
          "Digitalisation in oncology: The aim of this thesis is to examine the current situation of digital solutions in oncology, focusing on international IT solutions for cancer therapy and their possible implementation in Austria.",
      image: require("./assets/images/ba.jpg"),
      footerLink: [
        {
          name: "Bachelorthesis",
              url: "https://drive.google.com/file/d/1WHAC7kClAhbl4AyyS0rr7LaOiwqGVdra/view?usp=sharing"
        }
      ]
    },


    {
      title: "How to hack a company - collecting information",
      subtitle:
          "In this 30-page seminar paper, I show methods and techniques for gathering information about a company. From a company perspective, this guide can be used to prepare for an attack and to understand how an attacker thinks and how best to protect themselves.",
      image: require("./assets/images/hu-is-q.png"),
      footerLink: [
        {
          name: "Seminar paper",
              url: "https://drive.google.com/file/d/1AVXRLSPtiZrDmbrWnAqql9Hw1_0cHo7f/view?usp=sharing"
        }
      ]
    },
  
    {
      image: require("./assets/images/wastebox-logo.png"),
      title: "Conception & implementation of a messaging service",
      subtitle: "In the project, a microservice was created that is used by the existing wastebox.biz app. The service sends various notifications to wastebox clients. The specific functionalities of the microservice are SMS, Android push notifications, iOS push notifications and e-mail.",
      footerLink: [
          {
              name: "Diploma thesis",
              url: "https://drive.google.com/file/d/1QG7NGZkKqi9pu47xu6NHuLSLuLMLXLrK/view?usp=sharing"
          }
      ]
  },

    {
      title: "Cisco Cybersecurity certificate",
      subtitle:
        "As part of the Cisco Networking Academy, I received two cybersecurity certificates, which enabled me to deepen my knowledge in the area of security.",
        image: require("./assets/images/cisco-cybersecurity.png"),
      footerLink: [
        {
              name: "Introduction to Cybersecurity",
              url: "https://drive.google.com/file/d/1N6RAfSa6hVF7Zk0555R8GNFis-I38P2i/view?usp=sharing"
          },
          {
              name: "Cybersecurity Essentials",
              url: "https://drive.google.com/file/d/17dpNRknRbYNrliWp_OLZtKU2zLcyj8Uc/view?usp=sharing"
          }
      ]
    },

    {
      title: "Cisco CCNA - Routing & Switching",
      subtitle: "Network technology certificate from Cisco for network technology knowledge in the area of routing & switching",
      image: require("./assets/images/ccna.jpg"),
      footerLink: [
        {name: "Certificate", url: ""},
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blog",
  subtitle:
    "I have published some of my projects as blog entries. I love writing and enjoy sharing my knowledge with others.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
        url: "https://medium.com/@fabiangreimel/smartmirror-mit-react-4e5a8b5f9586",
      title: "Smartmirror out of the Box",
      description:
        "In this project, I built a smart mirror from an old television, a Raspberry PI and my own React app."
    },

    {
      image: require("./assets/images/cisco-cybersecurity.png"),
      url: "https://styrialabs.com/photography/",
      title: "Photography Blog",
      description: "On this page you will find impressions about my hobby as a photographer, mostly pictures from Styria and from my travels. "
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  fullname: "Fabian Greimel, BSc",
  title: "Reach out to me! ☎️",
  subtitle:
    "Do you have any project ideas or just want to get in touch? My inbox is open to everyone, just write to me.",
  number: "+43 664 91 74 774",
  email_address: "fabiangreimel@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  photos,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
